import { useCallback } from 'react';
import { pick } from 'js/utils/ramda.util';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useGetErrorResponseMessage } from 'js/hooks/server';

import * as server from './server';
import * as helpers from '../helpers';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../store';

export const useFetchPlayerGamblingHistory = () => {
    const isMounted = useIsMounted();
    const dispatch = useDynamicReducerDispatch();
    const getErrorResponseMessage = useGetErrorResponseMessage();
    const { startDate, descriptions } = useDynamicReducerSelector(pick(['startDate', 'descriptions']));

    return useCallback(() => {
        if (!descriptions.length) {
            return;
        }

        dispatch(actions.toggleLoading(true));
        dispatch(actions.setError(''));

        (async () => {
            try {
                const response = await server.getPlayerLimitsHistory({
                    startDate,
                    descriptions: helpers.getDescriptions(descriptions)
                });
                const limits = helpers.parseLimits(response);

                isMounted() && dispatch(actions.updateLimits(limits));
            } catch (error) {
                isMounted() && dispatch(actions.setError(getErrorResponseMessage(error)));
            } finally {
                isMounted() && dispatch(actions.toggleLoading(false));
            }
        })();
    }, [startDate, dispatch, isMounted, descriptions, getErrorResponseMessage]);
};
